import React from 'react';

import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withTranslation } from 'react-i18next';

import { validateMail } from './validate';

const styles = theme => ({
  textField: {
    width: '100%',
  },
});

function Inputs(props) {
	const { input, classes, label, meta: { touched, error } } = props;
	
  return (
    <TextField
      {...input}
      label={label}
      className={classes.textField}
      margin="normal"
      variant="outlined"
      error={(touched && error?true:false)} 
      helperText={(touched && error)?error:""}  
      />
  );
}
Inputs.propTypes = {
  classes: PropTypes.object.isRequired,
};


// function CollectMail(props) {
//   const {handleSubmit, modalClose, showModal, classes} = props;
//   const required = value => (value || typeof value === 'string' ? undefined : 'Ce champ doit être rempli')
//   return (
//   	<Dialog
//   		open={showModal}
//       onClose={modalClose}
//       aria-labelledby="form-dialog-title"
//       >
//       <form onSubmit={handleSubmit}>
//         <DialogTitle id="form-dialog-title">Recevez le résultat par mail</DialogTitle>
//         <DialogContent>
          
// 					 <Field
// 			      label={"Votre nom"}
// 			      name="nom"
// 			      component={Inputs} 
//             classes={classes}
//             validate={required}
//             value={lastname}
// 				    />
// 					 <Field
// 			      label={"Votre prénom"}
// 			      name="prenom"
// 			      component={Inputs} 
//             classes={classes}
//             validate={required}
//             value={firstname}
// 				    />
// 					 <Field
// 			      label={"Votre email"}
// 			      name="email"
// 			      component={Inputs} 
//             classes={classes}
//             value={email}
// 				    />
				 
//         </DialogContent>
//         <DialogActions>
//           <Button
//             onClick={modalClose}
//             type='button'>
//             Annuler
//           </Button>
//           <Button
//             variant="contained"
//             color="primary"
//             type='submit'>
//             Envoyer
//           </Button>
//         </DialogActions>
//          </form>
//       </Dialog>
// 	);
// }

class CollectMail extends React.Component {
  constructor(props) {
    super(props);
    const { t } = props;
    const required = value => (value || typeof value === 'string' ? undefined : t('field_required'))

    this.handleChangeFirstname = this.handleChangeFirstname.bind(this);
    this.handleChangeLastname = this.handleChangeLastname.bind(this);
    this.handleChangeEmail = this.handleChangeEmail.bind(this);

    this.state = {
      firstname:'',
      lastname:'',
      email:''
    }
  }

  handleChangeFirstname(event) {
    this.setState({firstname:event.target.value})
  }

  handleChangeLastname(event) {
    this.setState({lastname:event.target.value})
  }

  handleChangeEmail(event) {
    this.setState({email:event.target.value})
  }

  render() {
    const { t } = this.props;
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.modalClose}
        aria-labelledby="form-dialog-title"
        >
        <form onSubmit={this.props.handleSubmit}>
          <DialogTitle id="form-dialog-title">{t('title_email_prompt')}</DialogTitle>
          <DialogContent>
            <Field
              label={t('lastname_field')}
              name="lastname"
              component={Inputs} 
              classes={this.props.classes}
              validate={this.required}
              value={this.state.lastname}
              onChange={this.handleChangeLastname}
              />
            <Field
              label={t('firstname_field')}
              name="firstname"
              component={Inputs} 
              classes={this.props.classes}
              validate={this.required}
              value={this.state.firstname}
              onChange={this.handleChangeFirstname}
              />
            <Field
              label={t('email_field')}
              name="email"
              component={Inputs} 
              classes={this.props.classes}
              value={this.state.email}
              onChange={this.handleChangeEmail}
              />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.props.modalClose}
              type='button'>
              {t("cancel_button")}
            </Button>
            <Button
              variant="contained"
              color="primary"
              type='submit'>
              {t("send_button")}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    )
  }
}

CollectMail = reduxForm({ 
  form: 'formEstimationMail',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true, 
  validate: validateMail
})(CollectMail);

CollectMail =  withStyles(styles)(CollectMail);
export default withTranslation()(CollectMail); 